module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._onClickClose($event)
      }
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "scroll_container",
    class: {
      'has-scroll-fx': _vm.store.scrollFx, 'has-virtual-scroll': _vm.store.virtualScroll
    }
  }, [_c('div', {
    ref: "inner",
    staticClass: "scroll_inner"
  }, [(_vm.preloaded) ? _c('div', {
    staticClass: "modal__inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal__header on-scroll"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.project.description)
    }
  })]), _vm._v(" "), _vm._l((_vm.project.sections), function(section) {
    return _c('div', {
      staticClass: "modal__section on-scroll"
    }, [(section.type == 'image') ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.assetPath + section.url,
        "alt": ""
      }
    }), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()]) : (section.type == 'video') ? _c('div', [_c('div', {
      class: {
        'vertical': section.vertical
      }
    }, [(section.url) ? [_c('video', {
      attrs: {
        "src": _vm.assetPath + section.url,
        "alt": "",
        "controls": ""
      }
    })] : _vm._e(), _vm._v(" "), (section.urls) ? [_c('video', {
      attrs: {
        "poster": _vm.assetPath + section.poster,
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.assetPath + section.urls.mp4,
        "type": "video/mp4"
      }
    }), _vm._v(" "), _c('source', {
      attrs: {
        "src": _vm.assetPath + section.urls.webm,
        "type": "video/webm"
      }
    })])] : _vm._e(), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()], 2)]) : (section.type == 'embed') ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    }), _vm._v(" "), (section.caption) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(section.caption)
      }
    }) : _vm._e()]) : (section.type == 'text') ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(section.content)
      }
    })]) : _vm._e()])
  })], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d289f8"}!./src/components/modal/modal.component.html
// module id = 155
// module chunks = 1